import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import GhostContentAPI from "@tryghost/content-api";
import { CalendarDays, ArrowRight, Clock, Search } from "lucide-react";
import Logo from '../Images/logo.png';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";
import { Helmet } from 'react-helmet';

// Initialize the Ghost Content API
const api = new GhostContentAPI({
    url: "https://trendhopper.ghost.io",
    key: "587865eb8bff414e953a4e3e99",
    version: "v5.0",
});

const Blog = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const posts = await api.posts.browse({ limit: 10 });
                console.log("Fetched posts:", posts);
                setPosts(posts);
            } catch (err) {
                console.error("Error fetching posts:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    if (loading) {
        return (
            <div className="min-h-screen bg-[#0A0E17]">
                <div className="container mx-auto py-16 px-4">
                    <div className="space-y-8 animate-pulse">
                        <div className="h-8 w-2/3 bg-slate-800 rounded mx-auto" />
                        <div className="h-4 w-1/2 bg-slate-800 rounded mx-auto" />
                        <div className="h-64 bg-slate-800 rounded-2xl" />
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {[...Array(6)].map((_, i) => (
                                <div key={i} className="h-48 bg-slate-800 rounded-xl" />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#0A0E17]">
            <Helmet>
                <link rel="canonical" href="https://www.trendhopper.ai/blog" />
            </Helmet>
            {/* Header */}
            <header className="border-b border-slate-800">
                <div className="container mx-auto px-4 h-16 flex items-center justify-between">
                    <div className="flex items-center gap-6">
                        <Link to="/" className="flex items-center space-x-2">
                            <img
                                src={Logo}
                                alt=""
                                className="h-8 w-8"
                            />
                            <span className="font-semibold text-white">Trendhopper</span>
                        </Link>
                        <nav className="hidden md:flex gap-4">
                            <Link to="/" className="text-sm font-medium text-slate-400 hover:text-white">
                                Home
                            </Link>
                        </nav>
                    </div>
                    <div className="flex items-center gap-4">
                        <button
                            onClick={() => loginWithRedirect()}
                            className="text-slate-400 hover:text-white px-4 py-2 rounded-md transition-colors"
                        >
                            Sign in
                        </button>
                        <button
                            onClick={() => loginWithRedirect()}

                            className="bg-[#FF6B4A] hover:bg-[#FF6B4A]/90 text-white font-bold px-4 py-2 rounded-md transition-transform transform hover:scale-105"
                        >
                            Start Now
                        </button>
                    </div>
                </div>
            </header>

            <div className="container mx-auto py-16 px-4">
                {/* Latest Section */}
                <div className="mb-16">
                    <h2 className="text-2xl font-bold text-white mb-8">LATEST</h2>

                    {/* Featured Post */}
                    {/* Featured Post */}
                    {posts[0] && (
                        <Link
                            to={`/blog/${posts[0].slug}`}
                            className="group block bg-slate-800/50 rounded-2xl overflow-hidden hover:bg-slate-800/70 transition-all duration-300"
                        >
                            {/* Featured Image */}
                            {posts[0].feature_image && (
                                <img
                                    src={posts[0].feature_image}
                                    alt={posts[0].title}
                                    className="w-full h-64 object-cover"
                                />
                            )}

                            <div className="p-8 md:p-12">
                                <div className="flex items-center gap-4 text-[#FF6B4A] mb-4">
                                    <CalendarDays className="w-4 h-4" />
                                    <span className="text-sm">{new Date(posts[0].published_at).toLocaleDateString()}</span>
                                    <Clock className="w-4 h-4 ml-4" />
                                    <span className="text-sm">{posts[0].reading_time} min read</span>
                                </div>
                                <h3 className="text-3xl md:text-4xl font-bold text-white mb-4 group-hover:text-[#FF6B4A] transition-colors">
                                    {posts[0].title}
                                </h3>
                                <p className="text-slate-400 text-lg mb-6 line-clamp-3">{posts[0].excerpt}</p>
                                <div className="flex items-center text-[#FF6B4A] font-medium">
                                    Read More <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-2 transition-transform" />
                                </div>
                            </div>
                        </Link>
                    )}

                </div>

                {/* Grid of Posts */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {posts.slice(1).map((post) => (
                        <Link
                            to={`/blog/${post.slug}`}
                            key={post.id}
                            className="group bg-slate-800/50 rounded-xl overflow-hidden hover:bg-slate-800/70 transition-all duration-300"
                        >
                            <div className="p-6">
                                <div className="flex items-center gap-4 text-[#FF6B4A] mb-4 text-sm">
                                    <CalendarDays className="w-4 h-4" />
                                    <span>{new Date(post.published_at).toLocaleDateString()}</span>
                                </div>
                                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#FF6B4A] transition-colors">
                                    {post.title}
                                </h3>
                                <p className="text-slate-400 mb-4 line-clamp-2">{post.excerpt}</p>
                                <div className="flex items-center text-[#FF6B4A] text-sm font-medium">
                                    Read Article <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-2 transition-transform" />
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>

                {/* Show More Button */}
                <div className="mt-12 text-center">
                    <button
                        className="border border-slate-700 text-slate-400 px-4 py-2 rounded-md hover:text-white hover:bg-slate-800 transition-colors"
                    >
                        Show more
                        <span className="sr-only">Show more posts</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Blog;
